import { Component, Input } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';

/**
 * Generated class for the TagsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'comp-version-pro',
  templateUrl: 'version-pro.html',
})
export class VersionProPage {

  @Input() class_input;
  @Input() type;
  @Input() count;
  @Input() origin;
  @Input() modul;
  @Input() part;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public modalCtrl: ModalController) {
  }

  checkNumber(value) {
      if((typeof value) == 'number'){
        if(value < 0){
          return false;
        } else {
          return true;
        }
      }
      return false;
  }

  openVersionPro() {
    //link a wordpress
    //this.globals.openLandingPricing();
    if (this.globals.restaurant.license == 'free') {
      this.globals.openPayProMonthBlank();
    } else if (this.globals.restaurant.license == 'basic') {
      this.globals.openPayProMonthBlank();
    } else if (this.globals.restaurant.license == 'pro') {
      this.globals.openPayBusinessMonthBlank();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/version-pro/version-pro.ts